import { useState } from "react";
import type { FaqItem } from "@/lib/types";

export default function Faq({ items = [] }: { items?: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <span className="inline-block text-sm font-semibold text-primary-600">
            Questions fréquentes
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Tout savoir sur votre don
          </h2>
        </div>

        <div className="mt-10 space-y-4">
          {items.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.question}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading text-base font-semibold text-foreground-950">
                    {item.question}
                  </span>
                  <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-background-100 text-foreground-700">
                    <i
                      className={`text-lg ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}